export default {
    "fr": {
        "my_clients": "Mes clients",
        "add_client": "Ajouter un client",
        "create_client": "Créer un client",
        "my_inactive_clients": "Mes clients inactifs",
        "delete_client": "Supprimer le client",
        "no_clients": "Aucune client pour le moment",
        "company": "Société",
        "created_at": "Date de création",
        "status": "Statut",
        "mandate_state": "État du mandat",
        "active": "Actif",
        "inactive": "Inactif",
        "valid": "Valide",
        "invalid": "Invalide",
        "signed": "Signé",
        "not_signed": "Non signé",
        "no_mandate": "Pas de mandat",
        "upload_mandate": "Télécharger le mandat",
        "view_inactive_clients": "Voir les clients inactifs",
        "view_active_clients": "Voir les clients actifs",
        "select_type": "Sélectionner un type",
        "mandate_simplified": "Mandat simplifié",
        "mandate_complete": "Mandat complet",
        "mandate": {
            "email": "Adresse mail du client final",
            "phone": "Téléphone du client final",
            "user_name": "Nom complet du destinataire"
        },
        "mandate_text": "Pour que nous puissions vous représenter, vous devez signer un mandat de représentation en douane nous autorisant à le faire.\n\tIl existe plusieurs types de mandat, le modèle simplifié qui vous donnera accès à des missions d'assistance et de représentation auprès de la douane et du SIVEP.\n\tEt un modèle complet qui nous autorise à réaliser pour votre compte des déclarations d'importation et d'exportation.\n\tChaque mandat doit être obligatoirement tamponné et signé, votre compte sera activé après validation du mandat par nos services.",
        "add_mandate": "Ajouter un mandat",
        "alert_mandate_complete": "Nous ne pouvons représenter que des sociétés qui sont fiscalement et physiquement présentes dans le territoire de l’union Européenne. Nous ne pouvons pas représenter les sociétés étrangères.",
        "accounts": "Comptes",
        "add_account": "Ajouter un compte",
        "update_client": "Modifier le client",
        "update_account": "Modifier le compte",
        "activation": "Activer/désactiver le client",
        "edit": "Modifier le client",
        "confirm_delete_account": "Êtes-vous sûr de vouloir supprimer ce compte ?",
        "search_client": "Rechercher un client avec son numéro de TVA",
        "search_by": "Vérifiez si le client est déjà enregistré en utilisant son numéro de TVA, puis ajoutez-le à votre compte.",
        "search_result_empty": "Aucun client n'a été trouvé avec ce numéro de TVA. Cliquez sur le bouton ci-dessous pour le créer",
        "already_attached": "Ce client est déjà attaché à votre compte.",
        "attach_client": "Attacher le client",
        "cannot_attach_self": "Vous ne pouvez pas vous lier à vous-même",
        "alert_type_importateur-exportateur": "J’importe ou j’exporte pour mon propre compte et au nom de ma société uniquement.",
        "alert_type_particulier": "J’importe ou j’exporte pour mon propre compte.",
        "alert_type_intermediaire": "Je ne suis pas l’importateur/exportateur des marchandises mais j’organise la création des formalités douanières pour le compte de mes clients. J’ai besoin de gérer plusieurs clients dans mon espace en ligne.",
        "alert_type_button": "Je confirme que je suis un ",
        "generate_mandate": "Générer un mandat"
    },
    "en": {
        "my_clients": "My clients",
        "add_client": "Add a client",
        "create_client": "Create a client",
        "delete_client": "Delete client",
        "my_inactive_clients": "My inactive clients",
        "no_clients": "No clients at the moment",
        "company": "Company",
        "created_at": "Creation date",
        "status": "Status",
        "mandate_state": "Mandate state",
        "active": "Active",
        "inactive": "Inactive",
        "valid": "Valid",
        "invalid": "Invalid",
        "signed": "Signed",
        "not_signed": "Not signed",
        "no_mandate": "No mandate",
        "upload_mandate": "Upload mandate",
        "view_inactive_clients": "View inactive clients",
        "view_active_clients": "View active clients",
        "select_type": "Select a type",
        "mandate_simplified": "Simplified mandate",
        "mandate_complete": "Complete mandate",
        "mandate": {
            "email": "Email of the final client",
            "phone": "Phone of the final client",
            "user_name": "Full name of the recipient"
        },
        "mandate_text": "In order to represent your customer, he must sign a customs power of attorney authorizing us to do so.\n    There are several types of mandate, the simplified model which will give you access to assistance and representation missions with customs and SIVEP.\n    And a complete model that allows us to make import and export declarations on behalf of your customer.\n    Each mandate must be stamped and signed, your account will be active after validation of the mandate by our services.",
        "add_mandate": "Add a mandate",
        "alert_mandate_complete": "We can only represent companies that are fiscally and physically present in the territory of\n    the European Union. We cannot represent foreign companies.",
        "accounts": "Accounts",
        "add_account": "Add an account",
        "update_account": "Update account",
        "update_client": "Update client",
        "confirm_delete_account": "Are you sure you want to delete this account?",
        "activation": "Activate/deactivate client",
        "edit": "Edit client",
        "search_client": "Search a client",
        "search_by": "Check if the client is already registered using their VAT number, then add them to your account.",
        "search_result_empty": "No client was found with this VAT number. Click the button below to create one.",
        "already_attached": "This client is already attached to your account.",
        "attach_client": "Attach client",
        "cannot_attach_self": "You cannot attach yourself to your account",
        "alert_type_importateur-exportateur": "I import or export for my own account and on behalf of my company only.",
        "alert_type_particulier": "I import or export for my own account.",
        "alert_type_intermediaire": "I am not the importer/exporter of goods but I organize the creation of customs formalities on behalf of my clients. I need to manage multiple clients in my online space.",
        "alert_type_button": "I confirm that I am a ",
        "generate_mandate": "Generate a mandate"
    }
}
